import React, { createContext } from "react"
import {
    displayValues,
    formValues,
} from "../../Store/reducers/formReducer/initialState"
import styles from "./StepContainer.module.css"
import { StepContainerProps, StepContextType } from "./types"
import { Steps } from "./Steps"
import { StepWrapper } from "./StepWrapper"
import { stepStatus } from "../../Store/reducers/stepReducer/initialState"

export const StepContext = createContext<StepContextType>({
    formState: formValues,
    displayState: displayValues,
    currentStep: 0,
    stepBoolean: stepStatus,
    handleNext: () => {},
    handlePrev: () => {},
    setFormValue: () => {},
    updateUserResume: () => {},
    setDisplayValue: () => {},
    webhook: '',
    isBlocking: false,
});
export const StepContainer = ({
    stepState,
    displayState,
    formState,
    handleNext,
    handlePrev,
    setFormValue,
    updateUserResume,
    setDisplayValue,
    webhook,
    isBlocking,
}: StepContainerProps) => {
    return (
      <>
        {isBlocking && <div className={styles.blockingOverlay} />}

        <StepContext.Provider
          value={{
            formState,
            displayState,
            currentStep: stepState.currentStep.currentStep,
            stepBoolean: stepState.stepStatus,
            handleNext,
            handlePrev,
            setFormValue,
            updateUserResume,
            setDisplayValue,
            webhook,
            isBlocking,
          }}
        >
            <StepWrapper currentStep={stepState.currentStep.currentStep}>
                {Steps.map(({ Component }, index) => (
                    <div key={index} className={styles.stepContent}>
                        <Component />
                    </div>
                ))}
            </StepWrapper>
        </StepContext.Provider>
      </>
    );
};
